export default __webpack_public_path__ + "static/media/rotate-ccw.85f46ac5.svg";